import React from 'react'

const FSEN = () => {
  return (
    <div className='footer-column-container'>
       <div className='footer-container-1 footer-heading'>
        <h3>STACK EXCHANGE NETWORK</h3>
      </div>
      <div className='footer-container-1'>
        <p>Technology</p>
      </div>
      <div className='footer-container-1'>
        <p>Culture & Recreation</p>
      </div>
      <div className='footer-container-1'>
        <p>Science</p>
      </div>
      <div className='footer-container-1'>
        <p>Professional</p>
      </div>
      <div className='footer-container-1'>
        <p>Business</p>
      </div>
      <div className='footer-container-1'>
        <p>API</p>
      </div>
      <div className='footer-container-1'>
        <p>Data</p>
      </div>
    </div>
  )
}

export default FSEN